import { useEffect } from 'react';
import { useLiveChat } from '../hooks/useLiveChat';
import { getCountry } from '../redux/localization/localizationSelectors';
import { useSelector } from '../redux/store';
import { isInfobipLiveChatEnabled } from '../redux/form/formSelectors';
import { getInfobipWidgetId } from '../common/environment';

declare global {
  interface Window {
    liveChat?: {
      (command: string, ...args: any[]): void;
      q?: any[];
      t?: number;
    };
  }

  let liveChat: typeof window.liveChat;
}

export const InfobipWidgetWrapper: React.FC = () => {
  const country = useSelector(getCountry);
  const isEnabled = useSelector(isInfobipLiveChatEnabled);

  const key = getInfobipWidgetId();

  useLiveChat({
    enabled: isEnabled,
    country,
    key,
  });

  useEffect(() => {
    if (!window.liveChat) return;

    if (isEnabled) {
      window.liveChat('show');
    } else {
      window.liveChat('hide');
    }
  }, [isEnabled]);

  return null;
};
